// React
import React, {Component} from 'react';
// Styles
import '../styles.scss';
// SVG
import {copySvg, successSvg} from "@assets";

export class Copy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copy: false
        }
    }

    handleAction = (e, copyText) => {
        e.stopPropagation();
        navigator && navigator.clipboard && navigator.clipboard.writeText(copyText);
        this.setState({copy: true});
        setTimeout(() => {
            this.setState({copy: false})
        }, 3000)
    }

    render() {
        const {copyText} = this.props;
        const {copy} = this.state;
        return (
            <div className={`platform_btn_copy ${copy ? "platform_btn_copy__success" : "platform_btn_copy__normal"}`} onClick={(e) => this.handleAction(e, copyText)}>
                {!copy ?
                    <span>{copySvg()}</span> :
                    <span className={"zoomIn"}>{successSvg()}</span>
                }
            </div>
        );
    }
}

